import { object, string, TypeOf } from 'zod';

/* -------------------------------- Luminance ------------------------------- */

export const Luminance = object({
    background: string(),
    foreground: string(),
    feature: string(),
    featureMouseover: string(),
});
export type Luminance = TypeOf<typeof Luminance>;

/* ------------------------------ ThemeSection ------------------------------ */

export const ThemeSection = object({
    luminance: Luminance,
    background: string(),
    feature: string(),
    featureText: string(),
    featureMouseover: string(),
    featureMouseoverText: string(),
    a: string(),
    b: string(),
    c: string(),
    d: string(),
    e: string(),
    logo: string().optional(),
    logoImageId: string().optional(),
});
export type ThemeSection = TypeOf<typeof ThemeSection>;

/* ---------------------------------- Theme --------------------------------- */

export const Theme = object({
    id: string(),
    favicon: string().optional(),
    sections: object({
        light: string(),
        mediumLight: string(),
        medium: string(),
        dark: string(),
        positive: string(),
        negative: string(),
        header: ThemeSection,
        menu: ThemeSection,
        page: ThemeSection,
        footer: ThemeSection,
        sideMenu: ThemeSection,
        links: object({
            image: string().optional(),
        }),
    }),
});
export type Theme = TypeOf<typeof Theme>;
